import { ExploreFilterComponentProps } from "@modules/new-explore/types";
import { useExplore } from "@modules/new-explore/hooks/useExplore";
import { FC } from "react";
import { useLayoutContext } from "@context/layout";
import { EXPLORE_BOUGHT } from "enums/new-explore/explore-bought";
import useExplorePreloadedData from "@templates/new-explore/hooks/useExplorePreloadedData";
import { getCookie } from "@utils/Cookies";
import {
  COOKIE_ACCESS_TOKEN_KEY,
  COOKIE_FRONT_TOKEN_KEY,
} from "@utils/constants";
import { Switch, SWITCH_SIZES } from "@shared/components/switch";

const ExploreBoughtStatus: FC<ExploreFilterComponentProps> = () => {
  const { userData } = useLayoutContext();

  const hasCookie = Boolean(
    getCookie().get(COOKIE_ACCESS_TOKEN_KEY) ||
      getCookie().get(COOKIE_FRONT_TOKEN_KEY)
  );

  const isLoggedIn = userData ? Boolean(userData.is_login) : hasCookie;

  const { addFilter, removeFilterByKey } = useExplore();

  const { activeFilters } = useExplorePreloadedData();
  const selectedActiveFilter = activeFilters?.bought?.filter_value || [];
  const activeBought = selectedActiveFilter?.[0]?.id;

  const checked = activeBought !== EXPLORE_BOUGHT.INCLUDE;
  const handleOnChange = () => {
    const newVal = !checked;
    if (newVal) removeFilterByKey("bought");
    else
      addFilter({
        filterName: "bought",
        value: EXPLORE_BOUGHT.INCLUDE,
        name: "همه آموزش‌ها",
        isSingle: true,
        withReplace: true,
      });
  };

  if (!isLoggedIn) return null;
  return (
    <div className="flex justify-between items-center">
      <p className="title-md-demibold text-fds-primary">
        فقط آموزش‌هایی که ندارم
      </p>
      <Switch
        size={SWITCH_SIZES.LARGE}
        checked={checked}
        onClick={handleOnChange}
      />
    </div>
  );
};

export default ExploreBoughtStatus;
